export enum FormSectionIdEnum {
  // Common sections at the top
  BASICS = "basics",

  // Domain sections
  ASSESSMENT = "assessment",
  PRESETS = "presets",
  CONNECTIONS = "connections",
  COMPATIBILITY = "compatibility",
  SPECS = "specs",
  INPUT_SPECS = "input-specs",
  OUTPUT_SPECS = "output-specs",
  INPUT_BINDINGS = "input-bindings",
  OUTPUT_BINDINGS = "output-bindings",
  PATTERN = "pattern",
  SEMANTICS = "semantics",
  SCIENCE = "science",
  CONFIGURATION = "configuration",
  SIMULATION = "simulation",

  // Exercise scheduling
  BEHAVIOR = "behavior",
  PRIORITIZATION = "prioritization",
  SUITABILITY = "suitability",
  CAMPAIGNS = "campaigns",
  LIMITS = "limits",

  // Common sections at the bottom
  SETTINGS = "settings",
  SECURITY = "security",
  STATUS = "status",
}
